module.exports = __webpack_public_path__ + "img/account-pin-lock.5b0235f9.svg";